<template>
  <div class="basic-flex-col">
    <div class="mb-2 basic-flex-row">
      <TText :value="`Work Packages`" font_weight="300" size="24" class="ml-1" />
    </div>
    <div class="mb-2 ml-1 basic-flex-row" v-for="wp in workpackages" :key="`workpackage${wp.id}`">
      <WorkPackage
        :workpackage_count="1"
        :workpackage="wp"
        :zoom="1"
        />
      <DisableableInputField
        label="TA.name"
        class="ml-1"
        :is_disabled="true"
        :value="wp.ta_name"
        background_color="color-7"
        width="100px"
      />
      <DisableableInputField
        label="Token"
        class="ml-1"
        :is_disabled="!isEditMode"
        :value="wp.token"
        background_color="color-7"
        width="100px"
        @change="updateWP({val: $event, key: 'token', t_id: wp.t_id, ta_id: wp.ta_id, tw_id: wp.tw_id, id: wp.id})"
      />
      <DisableableInputField
        label="Name"
        class="ml-1"
        :is_disabled="!isEditMode"
        :value="wp.name"
        background_color="color-7"
        width="200px"
        @change="updateWP({val: $event, key: 'name', t_id: wp.t_id, ta_id: wp.ta_id, tw_id: wp.tw_id, id: wp.id})"
      />
      <DisableableInputField
        label="Description"
        class="ml-1"
        :is_disabled="!isEditMode"
        :value="wp.description"
        background_color="color-7"
        width="300px"
        @change="updateWP({val: $event, key: 'description', t_id: wp.t_id, ta_id: wp.ta_id, tw_id: wp.tw_id, id: wp.id})"
      />
      <DisableableInputField
        label="Manpower"
        class="ml-1"
        :is_disabled="!isEditMode"
        :value="wp.manpower_planned"
        background_color="color-7"
        width="100px"
        @change="updateWP({val: $event, key: 'manpower_planned', t_id: wp.t_id, ta_id: wp.ta_id, tw_id: wp.tw_id, id: wp.id})"
      />
      <DisableableInputField
        label="Time Effort"
        class="ml-1"
        :is_disabled="!isEditMode"
        :value="wp.time_effort_planned"
        background_color="color-7"
        width="100px"
        @change="updateWP({val: $event, key: 'time_effort_planned', t_id: wp.t_id, ta_id: wp.ta_id, tw_id: wp.tw_id, id: wp.id})"
      />
    </div>
  </div>
</template>
<script>
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    DisableableInputField,
    WorkPackage,
  },
  data() {
    return {}
  },
  created(){
  },
  computed: {
    project(){
      return this.getUObject({ type: 'projects', id: this.$route.params.project_id });
    },
    workpackages(){
      let workpackages = [];

      if(this.project){
        const trains = this.getUObjects({ type: 'trains', ids: this.project.trains });
        trains.forEach(train => {
          const taktareas = this.getUObjects({ type: 'taktareas', ids: train.taktareas });
          taktareas.forEach(taktarea => {
            const twaggons = this.getUObjects({ type: 'twaggons', ids: taktarea.twaggons });
            twaggons.forEach(twaggon => {
              const tworkpackages = this.getUObjects({ type: 'tworkpackages', ids: twaggon.tworkpackages });
              tworkpackages.forEach(twp => {
                workpackages.push({
                  id: twp.id,
                  name: twp.name,
                  description: twp.description,
                  token: twp.token,
                  color: twp.color,
                  icon: twp.icon,
                  manpower_planned: twp.manpower_planned,
                  time_effort_planned: twp.time_effort_planned,
                  time_effort_source: twp.time_effort_source,
                  tw_token: twaggon.token, 
                  tw_id: twaggon.id,
                  ta_name: taktarea.name,
                  ta_id: taktarea.id,
                  t_name: train.name,
                  t_id: train.id,
                });
              });
            });
          });
        });
      }

      return workpackages;
    },
    
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Project', [
      'isEditMode',
    ]),
  },
  methods: {
    ...mapActions('Ultra', [
      'updateUObject',
    ]),
    updateWP(payload){
      this.updateUObject({
        url: [
          { projects: this.project.id },
          { trains: payload.t_id },
          { taktareas: payload.ta_id },
          { twaggons: payload.tw_id },
          { tworkpackages: payload.id }
        ],
        update: {
          [payload.key]: payload.val
        }
      });
    }
  }
}
</script>
